import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isLoading: false
    },
    mutations: {
        SET_LOADING(state, status) {
            state.isLoading = status;
        }
    },
    actions: {
        setLoading({ commit }, status) {
            commit('SET_LOADING', status);
        }
    },
    getters: {
        isLoading: state => state.isLoading
    }
});
